import React from "react";
import { connect } from "react-redux";
import * as Tools from "../../helpers/Tools";
import { capitalize } from "lodash";


const OverviewConfirmation = ({ serviceLocation, selectedDateTime, selectedVaccines, cities }) => {

    const { address1, address2, city, state, zipCode, email, mobilePhone } = serviceLocation;

    const formatCity = (cityName) => {
        if (cityName && cities) {
            let formattedCity = cities.find(c => c.value === cityName.toLowerCase())
            if (formattedCity) return formattedCity.label;
        }
        return cityName;
    }

    const extractDay = () => {
        let newDate = new Date(selectedDateTime);
        const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        return weekday[newDate.getDay()]
    }

    const extractDate = () => {
        let newDate = new Date(selectedDateTime);
        const dayName = newDate.getDate();
        let monthName = newDate.getMonth() + 1;
        if (monthName < 10)
            monthName = "0" + monthName;
        return `${capitalize(Tools.getMonthName(monthName.toString()))} ${dayName}`;
    }

    const extractTime = () => {
        let newDate = new Date(selectedDateTime);
        let h = newDate.getHours();
        let m = newDate.getMinutes();
        h = h > 12 ? h - 12 : h;
        m = m < 10 ? "0" + m : m;
        return `${h.toString()}:${m.toString().padStart(2, '0')} `;
    }

    const extractTimeSuffix = () => {
        let newDate = new Date(selectedDateTime);
        let h = newDate.getHours();
        let ispm = h >= 12;
        return `${ispm ? "pm" : "am"}`;
    }

    return <div className="appointment-overview-container">
        <div className="text-container">
            <div className="date-time-section">
                {
                    selectedDateTime && <>
                        <span className="day-text">{extractDay()}</span><br />
                        <span className="date-text">{extractDate()}</span><br />
                        <span className="time-text">{extractTime()}</span><span className="time-suffix-text">{extractTimeSuffix()}</span>
                    </>
                }
            </div>
            <div>
            <div className="users-section">
                {
                    selectedVaccines && selectedVaccines.reduce((acc, user) => {
                        let vaxIsChecked = user.vaccines.filter(v => v.isChecked)
                        if (vaxIsChecked.length) {
                            acc.push(<div className="box" key={`${user.mrn}`}>
                                <span className="username-text">{user.patientName}</span><br />
                                {
                                    vaxIsChecked.map((vax) => (
                                        <span className="vaccine-name-text" key={vax.axleServiceId}>{vax.displayName} <br /></span>
                                    ))
                                }
                            </div>)
                }
                return acc;
                        
                    }, [])
                }
            </div>
            <div className="location-section">
                <span className="location-heading-text">Location & Contact Info</span><br />
                {
                    serviceLocation && <span className="location-text">
                        {address1}, {address2}<br />
                        {formatCity(city)}, {state}, {zipCode}<br />
                        {email}<br />
                        {mobilePhone}
                    </span>
                }
                </div>
                </div>
        </div>
    </div>
}

const mapStateToProps = state => {
    let finalConfirmationDetails = state.inHome.finalConfirmationDetails;

    return {
        serviceLocation: finalConfirmationDetails.serviceLocationContactInfo,
        selectedDateTime: finalConfirmationDetails.selectedDateTime,
        selectedVaccines: finalConfirmationDetails.selectedVaccines,
        cities: state.inHome.prefilledCities
    }
}

export default connect(mapStateToProps)(OverviewConfirmation);